import { Sun, CloudSun, Cloud, CloudDrizzle, CloudRain, CloudSunRain } from "lucide-react";

export const WEATHER_ICONS = {
  sunny: Sun,
  partly_cloudy: CloudSun,
  cloudy: Cloud,
  drizzle: CloudDrizzle,
  rain: CloudRain,
  mixed: CloudSunRain,
};

export const WeatherIcon = ({ weather, className = "w-4 h-4" }) => {
  const Icon = WEATHER_ICONS[weather];
  return Icon ? <Icon className={className} /> : null;
};
